import { Namespaces } from 'domain/common/namespaces';

export function isInMonitoringNamespace(attributeName: string): boolean {
  return attributeName.startsWith(`${Namespaces.Monitoring}/`);
}

export function isInSystemNamespace(attributeName: string): boolean {
  return attributeName.startsWith(`${Namespaces.System}/`);
}
